import { Button, Form, Input, Modal, message, Select } from "antd";
import { useState } from "react";
import { serverFetch } from "../../server";
import { userVids } from "@extensions/enums";

const CompanyItemUser = ({ companyId, visible, onClose }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      
      setLoading(true);
      
      const requestBody = {
        companyId,
        vid: values.vid,
        name: values.name,
        pass: values.pass
      };

      serverFetch("User", {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody)
      })
        .then(() => {
          setLoading(false);
          message.success("Пользователь добавлен");
          form.resetFields();
          onClose(true); // Передаем true для обновления списка
        })
        .catch((e) => {
          setLoading(false);
          message.error(e.userMessage);
        });
    } catch (errorInfo) {
      console.log('Validation failed:', errorInfo);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose(false);
  };

  return (
    <Modal
      title="Добавить пользователя"
      open={visible}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Отмена
        </Button>,
        <Button key="save" type="primary" onClick={handleSave} loading={loading}>
          Сохранить
        </Button>,
      ]}
      width={500}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        disabled={loading}
      >
        <Form.Item
          label="Вид"
          name="vid"
          rules={[{ required: true, message: 'Пожалуйста, выберите вид пользователя!' }]}
        >
          <Select 
            placeholder="Выберите вид пользователя"
            options={userVids}
          />
        </Form.Item>
        
        <Form.Item
          label="Имя"
          name="name"
          rules={[{ required: true, message: 'Пожалуйста, введите имя пользователя!' }]}
        >
          <Input placeholder="Введите имя пользователя" />
        </Form.Item>
        
        <Form.Item
          label="Пароль"
          name="pass"
        >
          <Input.Password placeholder="Введите пароль" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CompanyItemUser;
